import * as constAction from 'root/actionConstants';

// Dashboard
export const dashboard_changeTitle = title => ({
  type: constAction.DASHBOARD_CHANGE_TITLE,
  payload: title,
});

// Loadingbar
export const loadingbar_show = () => ({
  type: constAction.LOADINGBAR_SHOW,
});

export const loadingbar_hide = () => ({
  type: constAction.LOADINGBAR_HIDE,
});

export const startSockets = () => ({
  type: constAction.SOCKETS_GENERAL_START,
});

// Snackbar
export const snackbar_show = (message, duration) => ({
  type: constAction.SNACKBAR_SHOW,
  payload: {
    message,
    duration,
  },
});

export const snackbar_hide = () => ({
  type: constAction.SNACKBAR_HIDE,
});

export const seleccionador_close = () => ({
  type: constAction.SELECCIONADOR_CLOSE,
});

export const seleccionador_open = nombre => ({
  type: constAction.SELECCIONADOR_OPEN,
  payload: {
    nombre,
  },
});

export const seleccionador_setLista = (nombre, items) => ({
  type: constAction.SELECCIONADOR_SET_LISTA,
  payload: {
    nombre,
    items,
  },
});

export const seleccionador_clearLista = nombre => ({
  type: constAction.SELECCIONADOR_CLEAR_LISTA,
  payload: {
    nombre,
  },
});

/**
 * Conecta a un canal de socket
 * @param  {string} name       Nombre del canal
 * @param  {string} actionName Nombre de la accion a despachar
 */
export const joinSocket = (name, actionName, params = {}) => ({
  type: constAction.SOCKET_JOIN,
  payload: { name, actionName, params },
});

/**
 * Desconecta de un canal
 * @param  {string} name Nombre del canal
 */
export const leaveSocket = name => ({
  type: constAction.SOCKET_LEAVE,
  payload: name,
});

/**
 * Arma una accion, para guardar los datos de los sockets
 * @param  {string} type    Tipo de accion (constante)
 * @param  {Object} payload Datos recibidos via sockets
 * @return {Object}
 */
export const socketData = (type, payload) => ({
  type,
  payload,
});

export const reverseGeocoding = (latLng, formName, fieldName) => ({
  type: constAction.REVERSE_GEOCODING,
  payload: { latLng, formName, fieldName },
});



// WEBPACK FOOTER //
// src/modules/general/action.js